export class AwsEbsVolumeSnapshotProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "volume",
            "baseName": "volume",
            "type": "InventorySnapshotVolume",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEbsVolumeSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
